var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"show-filters",on:{"click":_vm.openFilters}},[_c('span',[_c('Search',{attrs:{"width":"15","color":"#939393"}})],1),_vm._v(_vm._s(_vm.$t("show_filters"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }